import React from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  setActiveTab: (tabId: string) => void;
  setSearchTerm: (term: string) => void;
}
export function TabNavigation({
  tabs,
  activeTab,
  setActiveTab,
  setSearchTerm
}: TabNavigationProps) {
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    setSearchTerm('');
  };
  return <div className="flex flex-wrap gap-2 mb-6 border-b-2 border-gray-200 pb-2" data-id="element-858">
      {tabs.map(tab => <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`px-5 py-3 text-sm font-medium rounded-t-lg transition-all duration-300 ${activeTab === tab.id ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-purple-500 hover:text-white'}`} data-id="element-859">
          {tab.label}
        </button>)}
    </div>;
}